define([
    "skylark-langx/langx"
], function(langx) {
    return langx;
});
